var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[("r-text " + _vm.type + " " + _vm.colorType)],style:(_vm.getStyle())},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }